export default "__VITE_ASSET___2Os365r__"